import axios from 'axios';
import { decryptData } from './encrypt';

export default function interceptorSetup () {
    axios.interceptors.request.use(function(config) {
        

      //Decrypt Token
      let mkLocalData = localStorage.getItem('token');
      if(!mkLocalData){
         mkLocalData = 'null';
      }
      const secretTokenKey = process.env.KEY || 'myscecretkey';
      const token = decryptData(mkLocalData, secretTokenKey);

        if(token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });

    axios.interceptors.response.use(
        response => response,
        error => {
          // Error
          const { config, response: { status } } = error;
      
          if (status === 401) {
            console.log(config);
            console.log('Caught the session error');
            var locale = JSON.parse(localStorage.getItem('lang'));
            localStorage.removeItem('login'); 
            localStorage.removeItem('Login');     
            axios.post(this.$hostName + '/logout', null)
            .then(() =>{
                this.$router.push({ path: locale + '/'});
             }).catch((error) =>{
                this.errors = error.response.data.errors;
            }).finally(() => {  
                localStorage.removeItem('token');
                localStorage.removeItem('Permissions');
                location.reload();
            });
          } else {
            return Promise.reject(error);
          }
        });
}